import React from "react";
import { Link } from "gatsby-link";

const buttonVariants = {
  primary:
    "text-lg text-white text-center xs:font-cairo font-medium bg-primary px-5 py-2 cursor-pointer inline-block",
  secondary:
    "text-lg text-black text-center xs:font-cairo font-medium bg-white px-5 py-2 cursor-pointer inline-block",
  outlined:
    "text-lg text-primary text-center xs:font-cairo font-medium bg-white px-5 py-2 border border-primary  cursor-pointer inline-block",
};

function Button({
  variant,
  className = "",
  onClick,
  title = "",
  link,
  style = {},
}) {
  return (
    <>
      {link ? (
        <Link
          to={link}
          style={style}
          className={`${buttonVariants[variant]} ${className}`}
          onClick={onClick}
        >
          {title}
        </Link>
      ) : (
        <button
          style={style}
          className={`${buttonVariants[variant]} ${className}`}
          onClick={onClick}
        >
          {title}
        </button>
      )}
    </>
  );
}
export default Button;
